import canvasLinkPlugin from './mirador-canvaslink';
import canvasRelatedLinksPlugin from './mirador-canvasRelatedLinks';
import citationsSidebarPlugin from './mirador-citations';
import collectionFoldersPlugin from './mirador-selectCollectionFolders';
import downloadDialogPlugin from './mirador-downloaddialog';
import hintingSideBar from './mirador-hinting-sidebar';
import nativeObjectViewerPlugin from './mirador-nativeObjectViewer';
import videojsPlugin from './mirador-videojs';
import viewerNavigation from './mirador-pageIconViewerNavigation';
import viewXmlPlugin from './mirador-viewXml';

export default {
  canvasLinkPlugin,
  canvasRelatedLinksPlugin,
  citationsSidebarPlugin,
  collectionFoldersPlugin,
  downloadDialogPlugin,
  hintingSideBar,
  nativeObjectViewerPlugin,
  videojsPlugin,
  viewerNavigation,
  viewXmlPlugin,
};
